<template>
    <div class="layer">
        <div class="wrap">
            <div id="header">
                <div class="header_wrap">
                    <button type="button" style="left: 29px; height: 54px" class="menu_btn" @click="backToList">
                        <img src="@/assets/logout.png" style="width: 100%" />
                    </button>
                    <span class="logo">META HEALTH</span>
                </div>
            </div>
            <div class="content">
                <div id="stress_layer">
                    <div class="stress_box">
                        <div class="surveyWrap">
                            <p class="survey_title">{{ currentQuestion.no }}. {{ currentQuestion.title }}</p>
                            <div class="surveySelectBox">
                                <template v-if="currentQuestion.type === 0">
                                    <div class="stress_bar">
                                        <VueSlider v-model="answer['content' + (result.currentPage + 1)]" />
                                        <div class="stress_bar_count">
                                            <b>0</b>
                                            <b>50</b>
                                            <b>100</b>
                                        </div>
                                    </div>
                                    <!-- <div class="stress_result" style="text-align: center;">
                                        <b>{{ answer['content' + (result.currentPage + 1)] }}</b>점
                                    </div> -->
                                </template>
                                <template v-if="currentQuestion.type === 1">
                                    <div class="survey_radio" v-for="(option, optIndex) in currentQuestion.choiceList"
                                        :key="optIndex">
                                        <label style="display: flex">
                                            <input type="radio" :name="'question' + currentQuestion.idx"
                                                :value="option.idx"
                                                v-model="answer['content' + (result.currentPage + 1)]" />
                                            <p style="margin-left: 10px">{{ option.title }}</p>
                                        </label>
                                    </div>
                                </template>
                                <template v-if="currentQuestion.type === 2">
                                    <div>{{ currentQuestion.leftContent }}</div>
                                    <div class="survey_radio_box">
                                        <div class="survey_radio" style="margin: 10px 0"
                                            v-for="(option, optIndex) in currentQuestion.choiceList" :key="optIndex">
                                            <label style="display: flex">
                                                <input type="radio" :name="'question' + currentQuestion.idx"
                                                    :value="option.idx"
                                                    v-model="answer['content' + (result.currentPage + 1)]" />
                                                <p style="margin-left: 10px">{{ option.title }}</p>
                                            </label>
                                        </div>
                                    </div>
                                    <div>{{ currentQuestion.rightContent }}</div>
                                </template>
                                <template v-if="currentQuestion.type === 3">
                                    <input type="text" v-model="answer['content' + (result.currentPage + 1)]"
                                        :placeholder="currentQuestion.title" style="border: 1px solid; width: 100%" />
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="btn_wrap">
                        <button type="button" class="submit_btn" v-if="result.currentPage !== 0" @click="prevQuestion">
                            이전
                        </button>
                        <button type="button" class="submit_btn" v-if="result.currentPage === survey.list.length - 1"
                            @click="checkSurvey" :disabled="isNextDisabled">
                            제출하기
                        </button>
                        <button type="button" class="submit_btn" v-if="result.currentPage !== survey.list.length - 1"
                            @click="nextQuestion" :disabled="isNextDisabled">
                            다음
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ModalComponent :show="state.isModalOpen" :yes="modal.confirm" :no="modal.cancel" :content="modal.content"
        @close="modalClose">
    </ModalComponent>
</template>

<script lang="ts">
import { ModalComponent, apiService, reactive, computed, onMounted, dateFormat } from "@/BaseComponent";
import { useRouter } from "vue-router";
import VueSlider from "vue-3-slider-component";
import survey from "./surveyList.json";
import "../../../public/css/style_test.css";

export default {
    components: {
        ModalComponent,
        VueSlider,
    },
    setup() {
        const state = reactive({
            value: "",
            isModalOpen: false,
            data: {} as any
        });

        const modal = reactive({
            confirm: "",
            cancel: "",
            content: "",
        });

        const result = reactive({
            currentPage: 0,
            selectRadio: null as number | null,
        });

        const answer: any = reactive({
            content1: 50,
            content2: 50,
            content3: null,
            content4: "", //3-1
            content5: "", //3-2
            content6: null,
            content7: "", //4-1
            content8: "", //4-2
            content9: null,
            content10: null,
            content11: null,
            hour: 0,
            date: dateFormat(new Date()),
            token: "string",
        });

        const router = useRouter();

        const currentQuestion = computed(() => survey.list[result.currentPage]);

        onMounted(() => {
            if (history.state != null) {
                state.data = history.state;
                answer.token = history.state.token;
                answer.date = state.data.date;
                answer.hour = state.data.idx + 1;
                if (history.state.content) {
                    answer.content1 = history.state.content;
                    answer.content2 = history.state.content2;
                    answer.content3 = history.state.content3;
                    answer.content4 = history.state.content4;
                    answer.content5 = history.state.content5;
                    answer.content6 = history.state.content6;
                    answer.content7 = history.state.content7;
                    answer.content8 = history.state.content8;
                    answer.content9 = history.state.content9;
                    answer.content10 = history.state.content10;
                    answer.content11 = history.state.content11;
                }
            }
        });

        const submitStressValue = async () => {
            const res = await apiService.base.addVasSurvey(
                state.value,
                "",
                "",
                state.data.date,
                state.data.idx + 1,
                state.data.token,
                answer,
            );
            if (res.returnCode === 0) {
                modal.content = "제출이 완료되었습니다.";
                modal.confirm = "확인";
                modal.cancel = "";
                state.isModalOpen = true;
            } else {
                modal.content = res.description;
                modal.confirm = "";
                modal.cancel = "확인";
                state.isModalOpen = true;
            }
        };

        const backToList = () => {
            router.back();
        };

        const modalClose = (result: boolean) => {
            state.isModalOpen = false;
            if (result) {
                if (modal.content === "제출하시겠습니까?") {
                    submitStressValue();
                } else if (modal.content === "제출이 완료되었습니다.") {
                    router.back();
                }
            }
        };

        const prevQuestion = () => {
            if (result.currentPage > 0) {
                if (result.currentPage === 5) {
                    const answerValue = answer["content3"];
                    if (answerValue === "0" || answerValue === 0) {
                        result.currentPage = 4;
                    } else {
                        result.currentPage = 2;
                        answer.content4 = "";
                        answer.content5 = "";
                    }
                } else if (result.currentPage === 8) {
                    const answerValue = answer["content6"];
                    if (answerValue === "0" || answerValue === 0) {
                        result.currentPage = 7;
                    } else {
                        result.currentPage = 5;
                        answer.content7 = "";
                        answer.content8 = "";
                    }
                } else {
                    result.currentPage--;
                }
                result.selectRadio = answer["content" + (result.currentPage + 1)];
            }
        };

        const nextQuestion = () => {
            if (result.currentPage < survey.list.length - 1) {
                if (result.currentPage === 2) {
                    const answerValue = answer["content" + (result.currentPage + 1)];
                    if (answerValue === "0" || answerValue === 0) {
                        result.currentPage = 3;
                    } else {
                        result.currentPage = 5;
                        answer.content4 = "";
                        answer.content5 = "";
                    }
                } else if (result.currentPage === 5) {
                    const answerValue = answer["content" + (result.currentPage + 1)];
                    if (answerValue === "0" || answerValue === 0) {
                        result.currentPage = 6;
                    } else {
                        result.currentPage = 8;
                        answer.content7 = "";
                        answer.content8 = "";
                    }
                } else {
                    result.currentPage++;
                }
                result.selectRadio = answer["content" + (result.currentPage + 1)];
            }
        };

        const checkSurvey = () => {
            let isValid = true;
            for (let i = 0; i < survey.list.length; i++) {
                if ([4, 5, 7, 8].includes(i + 1)) {
                    continue;
                }
                if (answer["content" + (i + 1)] === null || answer["content" + (i + 1)] === "") {
                    result.currentPage = i;
                    isValid = false;
                    break;
                }
            }

            if (!isValid) {
                modal.content = "비어있는 문항이있습니다.<br> 문항으로 이동됩니다.";
                modal.cancel = "확인";
                state.isModalOpen = true;
            } else {
                const nowDate = new Date();
                if (state.data.date === dateFormat(new Date()) || state.data.date === dateFormat(new Date(nowDate.setDate(nowDate.getDate() - 1)))) {
                    modal.content = "제출하시겠습니까?";
                    modal.confirm = "확인";
                    modal.cancel = "취소";
                    state.isModalOpen = true;
                } else {
                    modal.content = "당일 또는 전날 설문만 수정이 가능합니다.";
                    modal.confirm = "";
                    modal.cancel = "확인";
                    state.isModalOpen = true;
                }
            }
        };

        const isNextDisabled = computed(() => {
            if (currentQuestion.value.type === 1 || currentQuestion.value.type === 2) {
                return (
                    answer["content" + (result.currentPage + 1)] === "" ||
                    answer["content" + (result.currentPage + 1)] === null
                );
            } else if (currentQuestion.value.type === 3) {
                return (
                    answer["content" + (result.currentPage + 1)] === "" ||
                    answer["content" + (result.currentPage + 1)] === null
                );
            }
            return false;
        });

        return {
            modal,
            state,
            backToList,
            modalClose,
            survey,
            result,
            currentQuestion,
            prevQuestion,
            nextQuestion,
            checkSurvey,
            isNextDisabled,
            answer,
        };
    },
};
</script>

<style scoped>
.btn_wrap {
    justify-content: space-between;
    display: flex;
}

.surveyWrap {
    text-align: left;
    line-height: 1.5;
    word-break: keep-all;
    font-size: 15px;
}

.stress_bar_count {
    position: unset !important;
    margin-top: 10px;
}

.survey_title {
    margin-bottom: 20px;
    font-size: 15px;
    font-weight: bold;
}

.survey_radio+.survey_radio {
    margin-top: 15px;
}

button:disabled {
    background-color: gray !important;
}
</style>
